export const CATEGORY_CLIENT_ACTION = {
    GET_CATEGORY_LIST: "CATEGORY_CLIENT_ACTION/GET_CATEGORY_LIST",
    CREATE_CATEGORY: "CATEGORY_CLIENT_ACTION/CREATE_CATEGORY",
};
